import type { IconProps } from './IconLibrary';

function FlowerIcon({ size = 40, ...props }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" {...props}>
      <path
        d="M20 36 C19 27 21 22 20 16"
        fill="none"
        stroke="#3d8b3d"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M20 27 C17 26 14 27 13 29"
        fill="none"
        stroke="#3d8b3d"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <g stroke="#2f2f2f" strokeWidth="1.2" strokeLinejoin="round">
        <ellipse cx="20" cy="9" rx="4" ry="6" fill="#e8608a" />
        <ellipse cx="20" cy="9" rx="4" ry="6" fill="#e8608a" transform="rotate(72 20 9)" />
        <ellipse cx="20" cy="9" rx="4" ry="6" fill="#e8608a" transform="rotate(144 20 9)" />
        <ellipse cx="20" cy="9" rx="4" ry="6" fill="#e8608a" transform="rotate(216 20 9)" />
        <ellipse cx="20" cy="9" rx="4" ry="6" fill="#e8608a" transform="rotate(288 20 9)" />
      </g>
      <circle cx="20" cy="9" r="3.2" fill="#f6d24b" stroke="#2f2f2f" strokeWidth="1.2" />
    </svg>
  );
}

export default FlowerIcon;
